// ============================================================================
// Registry — the list of every module's manifest. The sidebar (buildMenu) and
// the page switcher in App.jsx both read from here, so adding a module means
// adding its manifest to this list.
// ============================================================================
import { lazy } from 'react';
import { legacyManifests, hiddenPages } from '../modules/legacy/manifest';

// The frame's own HQ pages (Leadership section)
const frameManifest = {
  id: 'frame', mandate: 'frame', items: [
    { page: 'approvals', label: 'Approvals', icon: '✅', section: 'Leadership', roles: ['hq'], component: lazy(() => import('./pages/Approvals')) },
    { page: 'modules', label: 'Modules', icon: '🧩', section: 'Leadership', roles: ['hq'], component: lazy(() => import('./pages/ModulesAdmin')) },
    { page: 'honour', label: 'Honour Points', icon: '🏆', section: 'Leadership', roles: ['hq'], component: lazy(() => import('./pages/HonourAdmin')) },
    { page: 'audit', label: 'Audit Log', icon: '📜', section: 'Leadership', roles: ['hq'], component: lazy(() => import('./pages/AuditLog')) },
  ],
};

export const manifests = [frameManifest, ...legacyManifests];

// page id → React component, for every page in every manifest (+ hidden pages)
export function pageComponents(list = manifests) {
  const map = { ...hiddenPages };
  list.forEach((m) => m.items.forEach((item) => { map[item.page] = item.component; }));
  return map;
}
